import { Component, forwardRef, input, Resource, TemplateRef, viewChild } from '@angular/core';

import { RemoteDataPanelViewBase } from '../remote-data-panel-view.base';
import { PanelViewBase } from '@softline/ui-core';
import { ResourceContainerComponent } from '../../components/resource-container/resource-container.component';

@Component({
    selector: 'soft-table-panel-view',
  imports: [ResourceContainerComponent],
    templateUrl: './table.panel-view.html',
    styleUrl: './table.panel-view.css',
    providers: [
        { provide: PanelViewBase, useExisting: forwardRef(() => TablePanelView) },
        { provide: RemoteDataPanelViewBase, useExisting: forwardRef(() => TablePanelView) }
    ]
})
export class TablePanelView<T> extends RemoteDataPanelViewBase<T[]> {
  override name = input.required<string>();
  override label = input<string>('Tabelle');
  override icon = input<string>('fa-regular fa-table');
  override template = viewChild<TemplateRef<any>>('template');
  override resource = input.required<Resource<T[]>>();
}
